module.exports = __webpack_public_path__ + "static/img/nopic.fc008bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nopic.png
// module id = eABG
// module chunks = 2